export default __webpack_public_path__ + "static/media/photo--sm--misc-26.c39a7d3b.jpg";